import React from "react";
import styled from "styled-components";
import { animated, useSpring } from "react-spring";
import { useInView } from "react-intersection-observer";
import { device } from "../styles/media-query";
import { useMyMediaQuery } from "../hooks/useMediaQuery";

const Container = styled.section`
  z-index: 10;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${device.tablet} {
    padding: 20rem 6rem;
  }

  ${device.mobile} {
    padding: 12rem 2rem;
  }

  ${device.desktop} {
    padding: 20rem 4rem;
    max-width: 1080px;
    margin: 0 auto;
  }
`;

const Text = styled.div`
  color: white;
  font-weight: bold;
  text-align: center;

  ${device.desktop} {
    font-size: 12rem;
    line-height: 130px;
  }

  ${device.tablet} {
    font-size: 7.6rem;
    line-height: 98.8px;
  }

  ${device.mobile} {
    font-size: 5.5rem;
    line-height: 65px;
  }
`;

function Banner() {
  const { inView, ref } = useInView({ triggerOnce: true });

  const { isMobile } = useMyMediaQuery();
  const textStyle = useSpring({
    delay: 400,
    to: {
      transform: `translateY(${inView ? "0" : "30"}px)`,
      opacity: inView ? 1 : 0,
    },
    config: { duration: 500 },
  });

  return (
    <Container ref={ref}>
      <animated.div
        style={{
          ...textStyle,
        }}
      >
        <Text>
          WE {isMobile && <br />}
          MAKE
        </Text>
        <Text>
          HYPER {isMobile && <br />}
          PROJECTS{" "}
        </Text>
      </animated.div>
    </Container>
  );
}

export default Banner;
